import AXIOS_INSTANCE from "..";
import { DongBoRequest } from "./Model/DongBoModel";
export default class DongBoService {
    constructor() { }
    dongBoDanhMucDungChung = (request: DongBoRequest) => {
        return AXIOS_INSTANCE.post('dong-bo/dong-bo-danh-muc-dung-chung', request,{timeout : 600000});
    }
}
